import { useCallback } from "react";

const initProjects = [
    "Categoría(s)",
    "Nombre de Proyecto",
    "Estatus",
    "Tamaño de Proyecto",
    "Horas de presupuesto desarrollo",
    "Hrs Assets",
    "Hrs Proveedores",
    "Hrs Servidor",
    "Hrs Planeación",
    "Hrs Diseño UI/UX",
    "Hrs Arte 3D",
    "Hrs Programación Unity",
    "Hrs Programación Web",
    "Hrs Consumo total",
    "Diferencia",
    "% Consumo",
    "Fecha de inicio de proyecto",
    "Fecha de cierre",
    "lideres de proyecto",
    "Responsable",
    "Comercial",
];

const useDownloadButton = (projects) => {
    const formatProjectDownloaded = useCallback((projects) => {
        if (!projects) return;
        const values = projects.map((project) => {
            const {
                categoryNames,
                name,
                status,
                size,
                totalDevelopment,
                assetTime,
                providerTime,
                serverTime,
                planning,
                design,
                art3d,
                unity,
                web,
                workingHours,
                differenceTime,
                percentage,
                startedDate,
                finished,
                leaders,
                peopleInCharge,
                peopleInChargeProject,
            } = project;
            return Object.values({
                categoryNames,
                name,
                status,
                size,
                totalDevelopment,
                assetTime,
                providerTime,
                serverTime,
                planning,
                design,
                art3d,
                unity,
                web,
                workingHours,
                differenceTime,
                percentage,
                startedDate,
                finished,
                leaders,
                peopleInCharge,
                peopleInChargeProject,
            });
        });

        return [initProjects].concat(values)
    }, []);




    return { formatProjectDownloaded };
};

export default useDownloadButton;
